/**
 * Clase que instancia nuestro objeto por default para hacer peticiones en la pagina de Tostador
 */
export class TostadorFetching {
  constructor(idSeccion, secuencia, ultimo = 0, frecuencia = 5, dias = 7) {
    this.idSeccion = idSeccion;
    this.secuencia = secuencia;
    this.ultimo = ultimo;
    this.frecuencia = frecuencia;
    this.dias = dias;
  }

  setIdSeccion(idSeccion) {
    this.idSeccion = idSeccion;
    return this;
  }

  setSecuencia(secuencia) {
    this.secuencia = secuencia;
    return this;
  }

  setUltimo(ultimo) {
    this.ultimo = ultimo;
    return this;
  }

  setFrecuencia(frecuencia) {
    this.frecuencia = frecuencia;
    return this;
  }

  setDias(dias) {
    this.dias = dias;
    return this;
  }
}
